export const oauthValidateScopes = "/oauth/validate_scopes";
